export default __webpack_public_path__ + "static/media/ProspectsActive.b3380c90.svg";